"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var system_1 = require("@retriever-ui/system");
var react_1 = __importDefault(require("react"));
var SBase = __importStar(require("../base.styled"));
var Messages_1 = __importDefault(require("../Messages"));
var ClosedEye_icon_1 = __importDefault(require("./ClosedEye.icon"));
var OpenedEye_icon_1 = __importDefault(require("./OpenedEye.icon"));
var S = __importStar(require("./password.styled"));
var Password = function (_a, ref) {
    var label = _a.label, _b = _a.name, name = _b === void 0 ? '' : _b, error = _a.error, props = __rest(_a, ["label", "name", "error"]);
    var _c = __read(react_1.default.useState('password'), 2), fieldType = _c[0], setFieldType = _c[1];
    var handleChangeInputType = react_1.default.useCallback(function () {
        setFieldType(function (lastType) { return (lastType === 'password' ? 'text' : 'password'); });
    }, []);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(system_1.retriever.div, { display: "flex", flexDirection: "column-reverse", position: "relative" },
            react_1.default.createElement(S.PasswordInputField, __assign({}, props, { name: name, type: fieldType, errored: (error === null || error === void 0 ? void 0 : error.message) !== undefined, id: name, ref: ref })),
            react_1.default.createElement(SBase.BaseLabel, { htmlFor: name }, label),
            react_1.default.createElement(S.ContentEyeIcon, null,
                fieldType === 'password' && (react_1.default.createElement(OpenedEye_icon_1.default, { onClick: !props.disabled || !props.readOnly
                        ? handleChangeInputType
                        : undefined })),
                fieldType === 'text' && (react_1.default.createElement(ClosedEye_icon_1.default, { onClick: !props.disabled || !props.readOnly
                        ? handleChangeInputType
                        : undefined })))),
        react_1.default.createElement(Messages_1.default, { error: error, readOnly: props.readOnly, disabled: props.disabled, warningMessage: props.warningMessage })));
};
exports.default = react_1.default.forwardRef(Password);
